export default "__VITE_ASSET__BNcXDFkc__"